module.exports = __webpack_public_path__ + "static/img/entrance1.48c1916.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/fcsw/entrance1.jpg
// module id = 57d2
// module chunks = 1